/**
 * Sticky Header
 * Adds a class to header on scroll
 */
// import magnificPopup from '../vendors/jquery-magnificpopup';
// import slick from '../vendors/slick.min';
import '../vendors/slick.min';
import '../vendors/jquery-magnificpopup';
import '../vendors/gsap.min';
import '../vendors/ScrollTrigger.min';
import '../vendors/owl.carousel.min';

/**
 * Home Slider
 *
 */
jQuery( window ).on( 'load', function() {
	// Run code
	const allCards = document.querySelectorAll( '.home-slider-box' );
	const cardsCount = allCards.length;

	for ( let i = 0; i < cardsCount; i++ ) {
		if ( i === 0 ) {
			allCards[ i ].classList.remove( 'no-active' );
			allCards[ i ].classList.add( 'active' );
			allCards[ i ].style.zIndex = cardsCount;
		} else {
			allCards[ i ].style.zIndex = cardsCount - i;
		}
	}

	function showNextSlide() {
		const activeCard = document.querySelector( '.home-slider-box.active' );
		const nextIndex =
            ( Array.from( allCards ).indexOf( activeCard ) + 1 ) % cardsCount;
		const nextCard = allCards[ nextIndex ];

		activeCard.style.opacity = '0';
		activeCard.classList.add( 'no-active' );
		activeCard.classList.remove( 'active' );

		nextCard.style.zIndex = cardsCount;
		nextCard.classList.remove( 'no-active' );
		nextCard.classList.add( 'active' );

		setTimeout( () => {
			activeCard.style.opacity = '1';
		}, 300 );

		for ( let i = 0; i < cardsCount; i++ ) {
			const currentIndex = ( nextIndex + i ) % cardsCount;
			const zIndex = cardsCount - i;

			if ( currentIndex !== nextIndex ) {
				allCards[ currentIndex ].style.zIndex = zIndex;
			}
		}
	}

	function showPreviousSlide() {
		const activeCard = document.querySelector( '.home-slider-box.active' );
		const prevIndex =
            ( Array.from( allCards ).indexOf( activeCard ) - 1 + cardsCount ) %
            cardsCount;
		const prevCard = allCards[ prevIndex ];

		activeCard.style.opacity = '0';
		activeCard.classList.remove( 'active' );

		prevCard.style.zIndex = cardsCount;
		prevCard.classList.add( 'active' );

		setTimeout( () => {
			activeCard.style.opacity = '1';
		}, 300 );

		for ( let i = 0; i < cardsCount; i++ ) {
			const currentIndex = ( prevIndex + i ) % cardsCount;
			const zIndex = cardsCount - i;

			if ( currentIndex !== prevIndex ) {
				allCards[ currentIndex ].style.zIndex = zIndex;
			}
		}
	}

	let autoRotateInterval;

	function startAutoRotation() {
		autoRotateInterval = setInterval( showNextSlide, 4000 ); // Rotate every 5 seconds (adjust as needed)
	}

	function stopAutoRotation() {
		clearInterval( autoRotateInterval );
	}

	if ( jQuery( '.home-slider-box' ).length > 0 ) {
		jQuery( '.home-slider-box' ).on( 'click', function() {
			if ( jQuery( this ).hasClass( 'no-active' ) ) {
				showNextSlide();
				stopAutoRotation(); // Stop auto rotation when user interacts with the slider
			}
		} );

		const prevArrow = document.querySelector( '.prev-arrow' );
		const nextArrow = document.querySelector( '.next-arrow' );

		prevArrow.addEventListener( 'click', showPreviousSlide );
		nextArrow.addEventListener( 'click', showNextSlide );

		// Start auto rotation when the page loads
		// let autoRotateInterval; // Variable to store the interval ID
		startAutoRotation();
	}
} );

//  document.all.body.style.paddingBottom="189px";
jQuery( document ).ready( function() {
	jQuery( '#clear-filter-category' ).on( 'click', function() {
		if ( jQuery( '.hero-section' ).hasClass( 'is-archive' ) ) {
			category_arr.push( {
				label: jQuery( '.hero-section' ).attr( 'data-label' ),
				value: jQuery( '.hero-section' ).attr( 'data-slug' ),
			} );
		}
		// Clear the search box
		jQuery( '.search-box' ).val( '' );

		const practices_area_cat = [];
		const industry_filter_cat = [];
		const attorneybios_filter_cat = [];

		jQuery( '.lds-roller' ).show();
		jQuery( '#category-posts' ).empty();
		jQuery( '.practice-reset' ).click();
		jQuery( '.industry-resert' ).click();
		jQuery( '.attorney-reset' ).click();
		jQuery( '.category-posts' ).empty();
		jQuery( '.pagination' ).remove();
		jQuery( '.subscribe-form-ctn' ).remove();

		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'post',
			dataType: 'json',
			data: {
				action: 'category_posts_filter',
				data: {
					practices_area_cat,
					industry_filter_cat,
					attorneybios_filter_cat,
					category_arr,
					search: '',
				},
			},
			success( response ) {
				jQuery( '.lds-roller' ).hide();
				if ( response.html ) {
					jQuery( '#category-posts' ).html( response.html );
				} else {
					jQuery( '#category-posts' ).html(
						'Oops, we could not find any results for your search.'
					);
				}
			},
			error( response ) {
				// Handle error response
			},
		} );
	} );

	if ( navigator.userAgent.indexOf( 'Mac OS X' ) !== -1 ) {
		jQuery( 'body' ).addClass( 'style-for-apple' );
	} else {
		jQuery( 'body' ).addClass( 'style-for-window' );
	}
	/**
	 * Toggle menu for mobile
	 */
	// accessible sub menu
	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
		} );

	jQuery( '.menu-btn' ).click( function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );

	jQuery( '.in-post-content' ).each( function() {
		if ( jQuery( this ).find( 'h2' ).height() > 32 ) {
			jQuery( this ).addClass( 'content-three-lines' );
		}
	} );

	/**
	 * Mega Mega
	 *
	 */

	jQuery( document ).ready( function() {
		// When submenu-icon is clicked
		jQuery( '.submenu-icon' ).on( 'click', function() {
			// Find the next sibling .mega-menu-ctn element
			const menuCtn = jQuery( this ).next( '.mega-menu-ctn' );
			menuCtn.addClass( 'active-menu' );
		} );

		// When menu-back-link is clicked
		jQuery( '.menu-back-link' ).on( 'click', function() {
			// Find the parent .mega-menu-ctn element
			const parentMenu = jQuery( this ).closest( '.mega-menu-ctn' );
			parentMenu.removeClass( 'active-menu' );

			// Find the parent <li> element and remove the active class
			const parentLi = parentMenu.closest( 'li' );
			parentLi.removeClass( 'active' );
		} );
	} );

	jQuery.noConflict();

	/**
	 * Drop Down
	 *
	 */

	jQuery( '.select-dropdown__button' ).on( 'click', function() {
		const dropdown = jQuery( this ).closest( '.select-dropdown' );
		dropdown
			.find( '.select-dropdown__button' )
			.toggleClass( 'is-button-opened' );
		dropdown
			.find( '.select-dropdown__list' )
			.toggleClass( 'is-active-dropdown' );
	} );
	/*
	 * Close popup on anywhere click
	 */
	jQuery( document ).mouseup( function( e ) {
		// const container = jQuery( '.select-dropdown__list' );
		const dropdowns = jQuery( '.select-dropdown' );
		dropdowns.each( function() {
			const dropdown = jQuery( this );
			const button = dropdown.find( '.select-dropdown__button' );
			const list = dropdown.find( '.select-dropdown__list' );
			if (
				! list.is( e.target ) &&
				list.has( e.target ).length === 0 &&
				! button.is( e.target ) &&
				button.has( e.target ).length === 0
			) {
				list.removeClass( 'is-active-dropdown' );
				button.removeClass( 'is-button-opened' );
			}
		} );
	} );
	jQuery( '.select-dropdown__sort-item' ).on( 'click', function() {
		const ratioText = 'Ratio';
		const itemValue = jQuery( this )
			.children()
			.find( '.select-dropdown__inner-title' )
			.data( ratioText );
		jQuery( this )
			.addClass( 'active-list' )
			.siblings()
			.removeClass( 'active-list' );
		jQuery( this )
			.parents( '.select-dropdown' )
			.find( '.select-dropdown__button span.dd-selected-value' )
			.text( jQuery( this ).text() )
			.parents()
			.attr( 'data-value', itemValue );
		jQuery( this )
			.parents( '.select-dropdown' )
			.find( '.select-dropdown__list' )
			.removeClass( 'is-active-dropdown' );
		jQuery( this )
			.parents( '.select-dropdown' )
			.find( '.select-dropdown__button.is-button-opened' )
			.removeClass( 'is-button-opened' );
	} );

	/**
	 * Read More
	 *
	 */

	const showChar = 500;
	const ellipsestext = '...';
	const moretext = 'Read More';
	const lesstext = 'Read less';
	jQuery( '.about-text-area' ).each( function() {
		const content = jQuery( this ).html();
		const textcontent = jQuery( this ).text();

		if ( textcontent.length > showChar ) {
			const c = textcontent.substr( 0, showChar );

			const html =
      '<span class="container"><span>' +
      c +
      '</span>' +
      '<span class="moreelipses">' +
      ellipsestext +
      '</span></span><span class="morecontent">' +
      content +
      '</span>';

			jQuery( this ).html( html );
			jQuery( this ).after( '<a href="#" class="more-btn-text">' + moretext + '</a>' );
		}
	} );

	jQuery( '.more-btn-text' ).click( function() {
		if ( jQuery( this ).hasClass( 'less' ) ) {
			jQuery( this ).removeClass( 'less' );
			jQuery( this ).html( moretext );
			jQuery( this ).prev().children( '.morecontent' ).hide();
			jQuery( this ).prev().children( '.container' ).show();
		} else {
			jQuery( this ).addClass( 'less' );
			jQuery( this ).html( lesstext );
			jQuery( this ).prev().children( '.container' ).hide();
			jQuery( this ).prev().children( '.morecontent' ).show();
		}

		return false;
	} );

	/**
	 * press-image-box
	 *
	 */
	jQuery( '.press-image-box' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		centerMode: true,
		centerPadding: '80px',

		asNavFor: '.press-content-box',
	} );
	jQuery( '.press-content-box' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.press-image-box',
		arrows: false,
		dots: false,
		adaptiveHeight: true,
	} );

	// jQuery( '.simple-quote-content-box' ).slick( {
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	autoplay: false,
	// 	arrows: false,
	// 	infinite: true,
	// 	dots: false,
	// 	adaptiveHeight: true,
	// } );

	if ( jQuery( window ).width() < 748 ) {
		 jQuery( '.res-post' ).slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			infinite: false,
			loop: false,
			centerPadding: '40px',
			dots: false,
			centerMode: true,
			touchThreshold: 200,
			variableWidth: true,
			adaptiveHeight: true,
		} );
	}

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.logo-grids ' ).slick( {
			slidesToShow: 5,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 550,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 460,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 360,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		} );
	}
	if ( jQuery( window ).width() < 748 ) {
		jQuery( '.representative-btns' ).on( 'click', function() {
			jQuery( this ).toggleClass( 'active' );
			jQuery( this ).find( '.menu-tabs' ).fadeIn( 'slow' );
			jQuery( this ).mouseleave( function() {
				jQuery( this )
					.find( '.menu-tabs' )
					.fadeOut( 'slow', function() {
						jQuery( this ).toggleClass( 'active' );
					} );
			} );
		} );

		jQuery( '.representative-btns .menu-link' ).on( 'click', function() {
			if (
				jQuery( this ).parents( '.menu-tabs' ).hasClass( 'active' )
			) {
				jQuery( this )
					.parents( '.representative-btns' )
					.removeClass( 'active' );
				jQuery( this ).parents( '.representative-btns' ).find( '.menu-tabs' ).fadeOut( 'slow', function() {
				 jQuery( this ).removeClass( 'active' ).addClass( 'unactive' );
				} );
			}
			const CurrentMenuLink = jQuery( this ).text();
			jQuery( '.representative-btns-title' ).text( CurrentMenuLink );
		} );
	}
	if ( jQuery( window ).width() < 748 ) {
		jQuery( '.industry-posts ' ).slick( {
			slidesToShow: 2,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			infinite: false,
			touchThreshold: 200,
			dots: false,
			centerPadding: '13px',

			responsive: [
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
					},
				},
			],
		} );

		if ( jQuery( '.team-member-ctn' ).length > 0 ) {
			jQuery( '.team-members ' ).slick( {
				slidesToShow: 2,
				slidesToScroll: 1,
				autoplay: false,
				arrows: true,
				dots: false,
				touchThreshold: 200,
				infinite: false,
				adaptiveHeight: true,
				centerPadding: '11px',
				responsive: [
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							centerMode: true,
							centerPadding: '11px',
						},
					},
				],
			} );
		}
	}
	if ( jQuery( window ).width() < 748 ) {
		jQuery( '.img-slide' ).slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: false,
			infinite: false,
			dots: false,
			centerMode: true,
			centerPadding: '30px',
		} );
		jQuery( '.resource-library-posts' ).slick( {
			slidesToShow: 2,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			infinite: false,
			dots: false,
			adaptiveHeight: true,

			responsive: [
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerPadding: '30px',
						centerMode: true,
					},
				},
			],
		} );
	}
	if ( jQuery( window ).width() < 748 ) {
		jQuery( '.icon-grids' ).slick( {
			slidesToShow: 2,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			infinite: false,
			responsive: [
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		} );
	}
	jQuery( '.video' ).magnificPopup( {
		type: 'iframe',
	} );

	jQuery.noConflict();

	if ( jQuery( window ).width() < 748 ) {
		jQuery( '.award-logos' ).slick( {
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: false,
			infinite: false,
			dots: true,
			responsive: [
				{
					breakpoint: 460,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 360,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		} );
	}
	// Block Menu Loction Mobile
	jQuery( '.attorney-slider' ).slick( {
		dots: false,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
  	    arrows: true,
		variableWidth: false,
		touchThreshold: 150,

		responsive: [
			{
				breakpoint: 1004,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 748,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					adaptiveHeight: true,
				},
			},
		],
	} );

	jQuery( window ).scroll( function() {
		if ( jQuery( this ).scrollTop() > 100 ) {
			jQuery( '.backtotop' ).fadeIn();
		} else {
			jQuery( '.backtotop' ).fadeOut();
		}
	} );
	jQuery( '.backtotop' ).click( function() {
		jQuery( 'html, body' ).animate( { scrollTop: 0 }, 100 );
		return false;
	} );

	/**
	 *
	 *
	 * Simple-quote Slider
	 *
	 */

	if ( jQuery( '.arrow-left' ).length > 0 ) {
		jQuery( '.arrow-left' ).click( function() {
			jQuery( '.simple-quote-content-box' ).slick( 'slickPrev' );
		} );
	}

	if ( jQuery( '.arrow-right' ).length > 0 ) {
		jQuery( '.arrow-right' ).click( function() {
			jQuery( '.simple-quote-content-box' ).slick( 'slickNext' );
		} );
	}

	/**
	 *
	 *
	 * Vertical Slider
	 *
	 */

	const heightSpeed = jQuery( '.custom-speed .res-post .single-rep-matter' ).length;

	if ( heightSpeed < 6 ) {
		var acutalHeight = 15;
	} else if ( heightSpeed < 11 ) {
		var acutalHeight = 30;
	} else if ( heightSpeed < 21 ) {
		acutalHeight = 40;
	} else if ( heightSpeed < 31 ) {
		acutalHeight = 50;
	} else if ( heightSpeed < 41 ) {
		acutalHeight = 90;
	} else if ( heightSpeed < 51 ) {
		acutalHeight = 110;
	} else if ( heightSpeed < 61 ) {
		acutalHeight = 140;
	} else if ( heightSpeed < 71 ) {
		acutalHeight = 200;
	} else if ( heightSpeed < 81 ) {
		acutalHeight = 280;
	} else if ( heightSpeed < 91 ) {
		acutalHeight = 320;
	} else if ( heightSpeed < 101 ) {
		acutalHeight = 380;
	} else {
		acutalHeight = 400;
	}

	if ( jQuery( window ).innerWidth() >= 748 ) {
		( function() {
			const cols = gsap.utils.toArray( '.res-post' );
			const ChckIfGsapLoaded = setInterval( function() {
				if ( window.gsap && window.ScrollTrigger ) {
					gsap.registerPlugin( ScrollTrigger );
					animateImages( cols );
					clearInterval( ChckIfGsapLoaded );
				}
			}, 100 );
			function animateImages( cols ) {
				let offset = 0;

				cols.forEach( ( col, i ) => {
					const images = col.childNodes;

					// DUPLICATE IMAGES FOR LOOP
					images.forEach( ( image ) => {
						const clone = image.cloneNode( true );
						col.appendChild( clone );
					} );

					// SET ANIMATION
					images.forEach( ( item ) => {
						const columnHeight = item.parentElement.offsetHeight;
						const direction = i % 2 !== 0 ? '+=' : '-='; // Change direction for odd columns
						const yOffset = direction === '+=' ? -offset : offset;

						const tween = gsap.to( item, {
							y: direction + Number( columnHeight / 2 ),
							duration: acutalHeight,
							repeat: -1,
							ease: 'none',
							onRepeat: () => {
								offset = 0;
							},
							modifiers: {
								y: gsap.utils.unitize( ( y ) => {
									y =
										( parseFloat( y ) + yOffset ) %
										( columnHeight * 0.5 );
									return y;
								} ),
							},
						} );
						document
							.querySelectorAll( '.res-post' )
							.forEach( ( img ) => {
								img.addEventListener( 'mouseover', () => {
									if ( tween ) {
										tween.pause();
									}
								} );

								img.addEventListener( 'mouseout', () => {
									if ( tween ) {
										tween.resume();
									}
								} );
							} );
					} );
				} );
			}
		}() );
	}
	/**
	 *
	 *
	 * Quote Slider
	 *
	 */

	const imageSlider = document.querySelector( '.quote-image-box' );
	const contentSlider = document.querySelector( '.quote-content-box' );
	const imageSlides = Array.from(
		document.querySelectorAll( '.quote-image-box .quote-img-area' )
	);
	const contentSlides = document.querySelectorAll(
		'.quote-content-box .quote-content'
	);

	let currentIndex = 0;
	if ( jQuery( '.quote-slider' ).length > 0 ) {
		contentSlides[ currentIndex ].style.opacity = '1';
		contentSlides[ currentIndex ].style.transform = 'translateX(0)';
		imageSlides[ currentIndex ].classList.add( 'active' );
		contentSlides[ currentIndex ].classList.add( 'active' );
		contentSlides[ currentIndex ].style.display = 'block';

		function changeSlide( index ) {
			imageSlides.forEach( ( slide ) => {
				slide.style.zIndex = '0';
			} );
			contentSlides.forEach( ( slide ) => {
				slide.style.display = 'none';
				slide.classList.remove( 'active' );
			} );

			contentSlides[ currentIndex ].style.opacity = '0';
			contentSlides[ currentIndex ].style.transform = 'translateX(-100%)';
			imageSlides[ currentIndex ].classList.remove( 'active' );

			currentIndex = index;

			contentSlides[ currentIndex ].style.display = 'block';
			contentSlides[ currentIndex ].style.opacity = '1';
			contentSlides[ currentIndex ].style.transform = 'translateX(0)';
			imageSlides[ currentIndex ].classList.add( 'active' );
			contentSlides[ currentIndex ].classList.add( 'active' );

			imageSlides.forEach( ( slide, i ) => {
				slide.style.zIndex = i === currentIndex ? '2' : '1';
			} );
		}

		const leftArrow = document.querySelector( '.quote-arrow.left-arrow' );
		if ( leftArrow ) {
			leftArrow.addEventListener( 'click', function( event ) {
				event.stopPropagation();
				const newIndex = ( currentIndex - 1 + imageSlides.length ) % imageSlides.length;
				changeSlide( newIndex );
				console.log( 'clicked left' );
			} );
		}
		const rightArrow = document.querySelector( '.quote-arrow.right-arrow' );
		if ( rightArrow ) {
			rightArrow.addEventListener( 'click', function( event ) {
				event.stopPropagation();
				const newIndex = ( currentIndex + 1 ) % imageSlides.length;
				changeSlide( newIndex );
				console.log( 'clicked right' );
			} );
		}

		// Remove the event listeners for click on imageSlider and contentSlider
		imageSlider.removeEventListener( 'click', null );
		contentSlider.removeEventListener( 'click', null );
	}

	/**
	 *
	 *
	 * Script for Menu Tabs
	 *
	 */

	jQuery( '.menu-tabs li span' ).on( 'click', function() {
		if ( jQuery( this ).hasClass( 'current' ) ) {
			jQuery( this ).removeClass( 'current' );
		} else {
			jQuery( '.menu-tabs li span' ).removeClass( 'current' );
			jQuery( this ).addClass( 'current' );
		}
	} );
	/**
	 *
	 *
	 * Script for Stats
	 */
	if ( jQuery( '.stats' ).length > 0 ) {
		const a = [];
		function isElementInViewport( el ) {
			const rect = el.getBoundingClientRect();
			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <=
					( window.innerHeight ||
						document.documentElement.clientHeight ) &&
				rect.right <=
					( window.innerWidth || document.documentElement.clientWidth )
			);
		}
		jQuery( window ).scroll( function() {
			jQuery( '.stats' ).each( function( index ) {
				if ( ! a[ index ] && isElementInViewport( this ) ) {
					jQuery( this )
						.find( '.stat-number' )
						.each( function() {
							const $this = jQuery( this ),
								countTo = $this.attr( 'data-number' );
							jQuery( {
								countNum: $this.text(),
							} ).animate(
								{
									countNum: countTo,
								},
								{
									duration: 5000,
									easing: 'swing',
									step() {
										$this.text(
											Math.ceil(
												this.countNum
											).toLocaleString( 'en' )
										);
									},
									complete() {
										$this.text(
											Math.ceil(
												this.countNum
											).toLocaleString( 'en' )
										);
									},
								}
							);
						} );
					a[ index ] = true;
				}
			} );
		} );
	}

	/**
	 *
	 *
	 * Script for Progress Bar
	 *
	 */
	if ( jQuery( '#progressBar' ).length ) {
		function progressBarScroll() {
			const articleDetailCtn = document.getElementsByClassName( 'article-detail-ctn' )[ 0 ];
			if ( ! articleDetailCtn ) {
				return;
			} // Check if element exists

			const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
			const articleDetailTop = articleDetailCtn.offsetTop;
			const articleDetailHeight = articleDetailCtn.offsetHeight;
			let scrolled = 0;

			if ( winScroll >= articleDetailTop ) {
				const scrollPosition = winScroll - articleDetailTop;
				const maxScroll = articleDetailHeight - window.innerHeight;
				scrolled = Math.min( scrollPosition / maxScroll, 1 ) * 100;
			}

			const progressBar = document.getElementById( 'progressBar' );
			progressBar.style.width = scrolled.toFixed( 2 ) + '%';
			progressBar.style.transition = 'width 0.5s'; // Adjust the transition duration as desired
		}

		// Throttling function to limit the scroll event frequency
		function throttle( func, delay ) {
			let timeoutId;
			return function() {
				if ( ! timeoutId ) {
					timeoutId = setTimeout( () => {
						func();
						timeoutId = null;
					}, delay );
				}
			};
		}

		const throttledProgressBarScroll = throttle( progressBarScroll, 500 ); // Adjust the delay as needed

		window.addEventListener( 'scroll', throttledProgressBarScroll );
	}

	jQuery( '.top-search' ).click( function() {
		jQuery( '.search-form-new' ).addClass( 'open' );
	} );
	jQuery( '.search-close' ).click( function() {
		jQuery( '.search-form-new' ).removeClass( 'open' );
	} );

	jQuery( '.select-dropdown__button' ).on( 'click', function() {
		jQuery( '.select-dropdown__list' ).toggleClass( 'active' );
	} );
	jQuery( '.select-dropdown__list-item' ).on( 'click', function() {
		const itemValue = jQuery( this ).data( 'value' );

		jQuery( '.select-dropdown__button span' )
			.text( jQuery( this ).text() )
			.parent()
			.attr( 'data-value', itemValue );
		jQuery( '.select-dropdown__list' ).toggleClass( 'active' );
	} );

	jQuery( '.list-view' ).on( 'click', function() {
		jQuery( '.list-view' )
			.parents()
			.find( '.attorney-ctn' )
			.removeClass( 'four-columns grid-view-ctn' );
		jQuery( '.list-view' )
			.parents()
			.find( '.attorney-ctn' )
			.addClass( 'list-view-ctn' );
		// Toggle class for current view
		jQuery( '.grid-view' ).removeClass( 'current' );
		jQuery( this ).addClass( 'current' );
	} );

	jQuery( '.grid-view' ).on( 'click', function() {
		jQuery( '.list-view' )
			.parents()
			.find( '.attorney-ctn' )
			.removeClass( 'list-view-ctn' );
		jQuery( '.list-view' )
			.parents()
			.find( '.attorney-ctn' )
			.addClass( 'four-columns grid-view-ctn' );
		// Toggle class for current view
		jQuery( this ).addClass( 'current' );
		jQuery( '.list-view' ).removeClass( 'current' );
	} );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */
	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );

	/**
	 *
	 * Script for Organic Tabs
	 *
	 */
	if ( jQuery( window ).width() < 748 ) {
		jQuery( '.tab-faq-heading' ).on( 'click', function() {
			if ( jQuery( this ).hasClass( 'current' ) ) {
				jQuery( this ).removeClass( 'current' );
				jQuery( this ).siblings( '.practice-partner-detail' ).slideUp();
			} else {
				jQuery( '.tab-faq-heading' ).removeClass( 'current' );
				jQuery( this ).addClass( 'current' );
				jQuery( '.practice-partner-detail' ).slideUp();
				jQuery( this ).siblings( '.practice-partner-detail' ).slideDown();
			}
		} );
		jQuery.noConflict();
		jQuery( '.tab-faq-heading' ).bind( 'click', function() {
			const self = this;

			if ( jQuery( 'body' ).hasClass( 'have-topbar' ) ) {
				setTimeout( function() {
					const theOffset = jQuery( self ).offset();
					jQuery( 'html' ).animate( {
						scrollTop: theOffset.top - 129,
					} );
				}, 410 );
			} else {
				setTimeout( function() {
					const theOffset = jQuery( self ).offset();
					jQuery( 'html' ).animate( {
						scrollTop: theOffset.top - 71,
					} );
				}, 410 );
			}
		} );
	}

	/**
	 * Smooth Scroll
	 *
	 */

	function scrollNav() {
		let linkClicked = false; // Flag variable to track link clicks

		jQuery( '.attorney-nav-inner a' ).click( function() {
			jQuery( '.current' ).removeClass( 'current' );
			jQuery( this ).addClass( 'current' );
			linkClicked = true; // Set the flag to true when a link is clicked

			const target = jQuery( jQuery( this ).attr( 'href' ) );
			const offset = target.offset().top - 250;

			jQuery( 'html, body' ).stop().animate(
				{
					scrollTop: offset,
				},
				500
			); // Adjust the duration value here (in milliseconds)
			return false;
		} );

		// Add current class when scrolling to section
		jQuery( window ).scroll( function() {
			const currentPosition = jQuery( 'html, body' ).scrollTop();
			jQuery( '.attorney-nav-inner a' ).each( function() {
				const sectionLink = jQuery( this );
				const sectionId = sectionLink.attr( 'href' );
				const sectionElement = jQuery( sectionId );

				if ( sectionElement.length ) {
					const sectionTop = sectionElement.offset().top - 280;
					const sectionBottom = sectionTop + sectionElement.outerHeight();

					if ( currentPosition >= sectionTop && currentPosition <= sectionBottom ) {
						if ( ! linkClicked ) {
							// Only update the current class if a link was not clicked
							jQuery( '.attorney-nav-inner a' ).removeClass( 'current' );
							sectionLink.addClass( 'current' );
						}
					}
				}
			} );

			linkClicked = false; // Reset the flag after checking the scroll position
		} );
	}

	scrollNav();

	const navID = '.attorney-nav-inner'; // Pass here the ID of navigation

	window.addEventListener( 'DOMContentLoaded', function() {
		const navLinks = document.querySelectorAll(
			'.attorney-nav-inner  ul li a'
		);
		const sections = document.querySelectorAll( 'section' );

		function scrollToSection( e ) {
			e.preventDefault();

			const targetId = this.getAttribute( 'href' ).substring( 1 );
			const targetSection = document.getElementById( targetId );

			if ( targetSection ) {
				targetSection.scrollIntoView( {
					behavior: 'smooth',
					block: 'start',
					inline: 'nearest',
				} );

				// Add current class to the clicked navigation item
				navLinks.forEach( function( link ) {
					link.classList.remove( 'current' );
				} );
				this.classList.add( 'current' );

				linkClicked = true; // Set the flag to true when a link is clicked
			}
		}

		navLinks.forEach( function( link ) {
			link.addEventListener( 'click', scrollToSection );
		} );

		// Set first navigation item as active by default
		navLinks[ 0 ].classList.add( 'current' );

		window.addEventListener( 'scroll', function() {
			const scrollPosition =
				document.querySelector( 'html' ).scrollTop ||
				document.querySelector( 'body' ).scrollTop;

			sections.forEach( function( section, index ) {
				const sectionTop = section.offsetTop;
				const sectionHeight = section.clientHeight;

				if (
					scrollPosition >= sectionTop - sectionHeight * 0.25 &&
					scrollPosition < sectionTop + sectionHeight * 0.75
				) {
					if ( ! linkClicked ) {
						// Only update the current class if a link was not clicked
						navLinks.forEach( function( link ) {
							link.classList.remove( 'current' );
						} );
						navLinks[ index ].classList.add( 'current' );
					}
				}
			} );

			linkClicked = false; // Reset the flag after checking the scroll position
		} );
	} );

	jQuery.noConflict();

	/**
	 *
	 * Script for Team Simple Mobile
	 *
	 */

	jQuery( '.show-bio' ).click( function() {
		const target = jQuery( this ).data( 'target' );
		const $targetItem = jQuery( '#' + target );

		jQuery( '.team-author-text' ).not( $targetItem ).slideUp(); // Close other items

		if ( $targetItem.is( ':hidden' ) ) {
			$targetItem.slideDown(); // Slide down if item is hidden
			jQuery( '.show-bio' ).not( this ).find( '.button-text' ).text( 'Show Bio' ); // Reset other button text
			jQuery( this ).find( '.button-text' ).text( 'Hide bio' ); // Set current button text to 'Close'
		} else {
			$targetItem.slideUp(); // Slide up if item is visible
			jQuery( this ).find( '.button-text' ).text( 'Show Bio' ); // Set current button text to 'Toggle'
		}
	} );

	jQuery.noConflict();
	/**
	 * Smooth Scroll article single
	 */
	jQuery( document ).ready( function() {
		jQuery( '.headings-list li a' ).click( function( e ) {
			e.preventDefault();
			const targetElement = jQuery( this.getAttribute( 'href' ) );
			if ( targetElement.length ) {
				jQuery( 'html, body' ).animate( {
					scrollTop: targetElement.offset().top,
				}, 500 );
			}
		} );
	} );

	jQuery.noConflict();

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */
	jQuery( '.header-nav .submenu-icon' ).click( function() {
		const link = jQuery( this );
		const closestUl = link.closest( 'ul' );
		const parallelActiveLinks = closestUl.find( '.active' );
		const closestLi = link.closest( 'li' );
		const linkStatus = closestLi.hasClass( 'active' );
		let count = 0;

		closestUl.find( 'ul' ).slideUp( function() {
			if ( ++count === closestUl.find( 'ul' ).length ) {
				parallelActiveLinks.removeClass( 'active' );
			}
		} );

		if ( ! linkStatus ) {
			closestLi.children( 'ul' ).slideDown();
			closestLi.addClass( 'active' );
		}
	} );

	function pad( d ) {
		return d < 10 ? '0' + d.toString() : d.toString();
	}
	jQuery.fn.fullHtml = function() {
		const items = [];
		this.each( function() {
			let html = '';
			const tagName = jQuery( this ).prop( 'tagName' ).toLowerCase();
			const attributes = this.attributes;
			html += '<' + tagName + ' ';
			jQuery.each( attributes, function() {
				html += ' ' + this.name + '="' + this.value + '"';
			} );
			html += '>' + jQuery( this ).html() + '</' + tagName + '>';
			items.push( html );
		} );
		return items;
	};

	if ( jQuery( 'body' ).hasClass( 'single-post' ) ) {
		let blogHTML = '';
		let count = 1;
		jQuery( '.article-detail-content' )
			.find( 'h2' )
			.each( function() {
				const id = jQuery( this )
					.text()
					.toLowerCase()
					.replace( /[^a-zA-Z0-9 ]/g, '' ).replace( /\s/g, '-' );
				jQuery( this ).replaceWith(
					'<div class="jump-link-post" id="' +
						id +
						'"></div>' +
						jQuery( this ).fullHtml()
				);
				if ( jQuery( this ).text() !== '' ) {
					blogHTML +=
						'<li><a href="#' +
						id +
						'">' +
						jQuery( this ).text() +
						'</a></li>';
					count++;
				}
			} );
		if ( blogHTML === '' ) {
			jQuery( '.ar-de-sidebar-head' ).hide();
			jQuery( '.ar-de-sidebar-list' ).hide();
		}
		jQuery( '.headings-list' ).prepend( blogHTML );
	}
} );

//filters
jQuery( document ).on( 'click', '#search-category-ajax', function( e ) {
	e.preventDefault();
	const form = jQuery( this ).parents( 'form#searchbox' );
	const search = form.find( '.search-box' ).val();
	const slug = form.find( '.search-box' ).attr( 'data-slug' );
	let practiceSlug = '';
	let attorneySlug = '';
	jQuery( '#select-practice-area' ).find( '.select-dropdown__sort-item.active-list' ).each( function() {
		practiceSlug = jQuery( this ).find( '.select-dropdown__inner-title' ).attr( 'data-slug' );
	} );
	jQuery( '#attorney-drop-down' ).find( '.select-dropdown__sort-item.active-list' ).each( function() {
		attorneySlug = jQuery( this ).find( '.select-dropdown__inner-title' ).attr( 'data-slug' );
	} );
	if ( history.pushState ) {
		let oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;

		if ( search !== '' ) {
			oldurl += '?search=' + search;
		}

		if ( attorneySlug !== '' ) {
			if ( oldurl.indexOf( '?' ) === -1 ) {
				oldurl += '?attorney=' + attorneySlug;
			} else {
				oldurl += '&attorney=' + attorneySlug;
			}
		}

		if ( practiceSlug !== '' ) {
			if ( oldurl.indexOf( '?' ) === -1 ) {
				oldurl += '?practice-area=' + practiceSlug;
			} else {
				oldurl += '&practice-area=' + practiceSlug;
			}
		}

		window.history.pushState( { path: oldurl }, '', oldurl );
	}
	jQuery( '#category-posts' ).html( '' );
	jQuery( '.lds-roller' ).show();
	jQuery.ajax( {
		url: localVars.ajax_url,
		type: 'post',
		dataType: 'json',
		data: {
			action: 'category_posts_filter',
			data: {
				search,
				slug,
				practiceSlug,
				attorneySlug,

			},
		},
		success( response ) {
			jQuery( '.lds-roller' ).hide();
			if ( response.html ) {
				jQuery( '#category-posts' ).html( response.html );
			} else {
				jQuery( '#category-posts' ).html(
					'Oops, we could not find any results for your search.'
				);
			}
		},
		error( response ) {
			jQuery( '.lds-roller' ).hide();
			jQuery( '#category-posts' ).html(
				'Oops, we could not find any results for your search.'
			);
		},
	} );
} );

jQuery( document ).on( 'click', '.pagination-category-ajax', function() {
	const form = jQuery( 'form#searchbox' );
	const search = form.find( '.search-box' ).val();
	const slug = form.find( '.search-box' ).attr( 'data-slug' );
	const page = jQuery( this ).attr( 'data-page' );
	let practiceSlug = '';
	let attorneySlug = '';
	jQuery( '#select-practice-area' ).find( '.select-dropdown__sort-item.active-list' ).each( function() {
		practiceSlug = checkUndefined( jQuery( this ).find( '.select-dropdown__inner-title' ).attr( 'data-slug' ) );
	} );
	jQuery( '#attorney-drop-down' ).find( '.select-dropdown__sort-item.active-list' ).each( function() {
		attorneySlug = checkUndefined( jQuery( this ).find( '.select-dropdown__inner-title' ).attr( 'data-slug' ) );
	} );
	if ( history.pushState ) {
		let oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
		if ( search !== '' ) {
			oldurl += '?search=' + search;
		}
		window.history.pushState( { path: oldurl }, '', oldurl );
	}
	if ( history.pushState ) {
		let oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;

		if ( search !== '' && page !== '' ) {
			oldurl += '?search=' + search + '&page=' + page;
		} else if ( page !== '' ) {
			oldurl += '?page=' + page;
		} else if ( search !== '' ) {
			oldurl += '?search=' + search;
		}

		if ( attorneySlug !== '' ) {
			if ( oldurl.indexOf( '?' ) === -1 ) {
				oldurl += '?attorney=' + attorneySlug;
			} else {
				oldurl += '&attorney=' + attorneySlug;
			}
		}

		if ( practiceSlug !== '' ) {
			if ( oldurl.indexOf( '?' ) === -1 ) {
				oldurl += '?practice-area=' + practiceSlug;
			} else {
				oldurl += '&practice-area=' + practiceSlug;
			}
		}

		window.history.pushState( { path: oldurl }, '', oldurl );
	}

	jQuery( 'html, body' ).animate( {
		scrollTop: jQuery( '#ajax-filter-scroll-to' ).offset().top - 350,
	}, 2000 );
	jQuery( '#category-posts' ).html( '' );
	jQuery( '.lds-roller' ).show();
	jQuery.ajax( {
		url: localVars.ajax_url,
		type: 'post',
		dataType: 'json',
		data: {
			action: 'category_posts_filter',
			data: {
				search,
				slug,
				page,
				practiceSlug,
				attorneySlug,
			},
		},
		success( response ) {
			jQuery( '.lds-roller' ).hide();
			if ( response.html ) {
				jQuery( '#category-posts' ).html( response.html );
			} else {
				jQuery( '#category-posts' ).html(
					'Oops, we could not find any results for your search.'
				);
			}
		},
		error( response ) {
			jQuery( '.lds-roller' ).hide();
			jQuery( '#category-posts' ).html(
				'Oops, we could not find any results for your search.'
			);
		},
	} );
} );

jQuery( document ).on( 'keydown', '.search-box', function( e ) {
	if ( parseInt( e.which ) === 13 ) {
		e.preventDefault();
		const form = jQuery( this ).parents( 'form#searchbox' );
		form.find( '#search-category-ajax' ).click();
	}
} );

jQuery( document ).on( 'click', '#clear-filter-category-ajax', function() {
	if ( history.pushState ) {
		const oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
		window.history.pushState( { path: oldurl }, '', oldurl );
	}
	jQuery( '.select-dropdown__sort-item' ).each( function() {
		jQuery( this ).removeClass( 'active-list' );
	} );
	jQuery( '.dd-selected-value' ).each( function() {
		jQuery( this ).text( jQuery( this ).attr( 'data-default' ) );
	} );
	jQuery( 'form#searchbox' ).find( '.search-box' ).val( '' );

	jQuery( 'form#searchbox' ).find( '.search-button' ).click();
} );

jQuery( document ).on( 'click', '.rep-matter-ajax', function() {
	const industry = checkUndefined( jQuery( '#industry-filter' ).find( 'li.select-dropdown__sort-item.active-list' ).attr( 'data-slug' ) );
	const attorney = checkUndefined( jQuery( '#attorneybios-filter' ).find( 'li.select-dropdown__sort-item.active-list' ).attr( 'data-slug' ) );
	const practiceArea = checkUndefined( jQuery( '#practice-area-filter' ).find( 'li.select-dropdown__sort-item.active-list' ).attr( 'data-slug' ) );
	console.log( practiceArea );
	const page = checkUndefined( jQuery( this ).attr( 'data-next' ), 'page' );
	const type = checkUndefined( jQuery( this ).attr( 'data-type' ) );

	if ( history.pushState ) {
		let oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
		if ( attorney !== '' && industry !== '' && practiceArea !== '' ) {
			oldurl += '?rep-attorney=' + attorney + '&rep-industry=' + industry + '&practice-area=' + practiceArea;
		} else if ( industry !== '' && attorney !== '' ) {
			oldurl += '?rep-industry=' + industry + '&rep-attorney=' + attorney;
		} else if ( attorney !== '' && practiceArea !== '' ) {
			oldurl += '?rep-attorney=' + attorney + '&practice-area=' + practiceArea;
		} else if ( industry !== '' && practiceArea !== '' ) {
			oldurl += '?rep-industry=' + industry + '&practice-area=' + practiceArea;
		} else if ( attorney !== '' ) {
			oldurl += '?attorney-area=' + attorney;
		} else if ( industry !== '' ) {
			oldurl += '?rep-industry=' + industry;
		} else if ( practiceArea !== '' ) {
			oldurl += '?practice-area=' + practiceArea;
		}
		window.history.pushState( { path: oldurl }, '', oldurl );
	}
	jQuery.ajax( {
		url: localVars.ajax_url,
		type: 'post',
		dataType: 'json',
		data: {
			action: 'representative_matters_filter',
			data: {
				industry,
				attorney,
				practiceArea,
				page,
			},
		},
		success( response ) {
			jQuery( '.lds-roller' ).hide();

			if ( response.html ) {
				if ( type === 'pagination' ) {
					jQuery( '#representative-posts' ).append( response.html );
				} else {
					jQuery( '#representative-posts' ).html( response.html );
				}
				jQuery( '.rep-matter-ajax[data-type="pagination"]' ).parent().show();
				jQuery( '.rep-matter-ajax[data-type="pagination"]' ).attr( 'data-next', response.next );
				jQuery( '.rep-matter-ajax[data-type="pagination"]' ).attr( 'data-current', response.current );
				jQuery( '.rep-matter-ajax[data-type="pagination"]' ).attr( 'data-pages', response.pages );
				jQuery( '#representative-posts' ).removeClass( 'no-representative-container' );
			} else {
				jQuery( '#representative-posts' ).html(
					'Oops, we could not find any results for your search.'
				);
				jQuery( '#representative-posts' ).addClass( 'no-representative-container' );
			}
			if ( response.pages == 1 ) {
				jQuery( '.rep-matter-ajax[data-type="pagination"]' ).parent().hide();
			}
			if ( response.next > response.pages ) {
				jQuery( '.rep-matter-ajax[data-type="pagination"]' ).parent().hide();
			}
		},
		error( response ) {
			jQuery( '.lds-roller' ).hide();
			jQuery( '#representative-posts' ).html(
				'Oops, we could not find any results for your search.'
			);
			jQuery( '#representative-posts' ).addClass( 'no-representative-container' );
		},

	} );
} );

jQuery( document ).on( 'click', '#clear-filter-rep-matters', function() {
	const industry = '';
	const attorney = '';
	const page = 1;
	const type = checkUndefined( jQuery( this ).attr( 'data-type' ) );
	jQuery( '.practice-reset' ).click();
	jQuery( '.industry-reset' ).click();
	jQuery( '.attorney-reset' ).click();
	if ( history.pushState ) {
		const oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
		window.history.pushState( { path: oldurl }, '', oldurl );
	}
	jQuery.ajax( {
		url: localVars.ajax_url,
		type: 'post',
		dataType: 'json',
		data: {
			action: 'representative_matters_filter',
			data: {
				industry,
				attorney,
				// page,
			},
		},
		success( response ) {
			jQuery( '.lds-roller' ).hide();

			if ( response.html ) {
				if ( type === 'pagination' ) {
					jQuery( '#representative-posts' ).append( response.html );
				} else {
					jQuery( '#representative-posts' ).html( response.html );
				}
				jQuery( '#count-representative' ).html( response.found_posts );
				jQuery( '.rep-matter-ajax[data-type="pagination"]' ).parent().show();
				jQuery( '.rep-matter-ajax[data-type="pagination"]' ).attr( 'data-next', response.next );
				jQuery( '.rep-matter-ajax[data-type="pagination"]' ).attr( 'data-current', response.current );
				jQuery( '.rep-matter-ajax[data-type="pagination"]' ).attr( 'data-pages', response.pages );
				jQuery( '#representative-posts' ).removeClass( 'no-representative-container' );
			} else {
				jQuery( '#representative-posts' ).html(
					'Oops, we could not find any results for your search.'
				);
				jQuery( '#count-representative' ).html( 0 );
				jQuery( '#representative-posts' ).addClass( 'no-representative-container' );
			}
			if ( response.pages == 1 ) {
				jQuery( '.rep-matter-ajax[data-type="pagination"]' ).parent().hide();
			}
			if ( response.next > response.pages ) {
				jQuery( '.rep-matter-ajax[data-type="pagination"]' ).parent().hide();
			}
		},
		error( response ) {
			jQuery( '.lds-roller' ).hide();
			jQuery( '#representative-posts' ).html(
				'Oops, we could not find any results for your search.'
			);
			jQuery( '#count-representative' ).html( 0 );
			jQuery( '#representative-posts' ).addClass( 'no-representative-container' );
		},

	} );
} );
function checkUndefined( item, type = 'normal' ) {
	if ( typeof item === 'undefined' ) {
		if ( type === 'page' ) {
			item = 1;
		} else {
			item = '';
		}
	}
	return item;
}

jQuery( document ).ready( function( ) {
	const itemsToShow = 6; // Number of posts to show on each load

	// Initially show the first 6 posts
	jQuery( '.representative-single-post' ).slice( 0, itemsToShow ).show();

	// Check if there are more than 6 posts to determine the button visibility
	if ( jQuery( '.representative-single-post' ).length > itemsToShow ) {
		jQuery( '.load-more' ).show();
	} else {
		jQuery( '.load-more' ).hide();
	}

	// Load More button click event
	jQuery( '.load-more-rep-matters' ).on( 'click', function() {
		// Show the next set of hidden posts
		jQuery( '.representative-single-post:hidden' ).slice( 0, itemsToShow ).fadeIn();

		// If no more hidden posts remain, hide the entire "Load More" div
		if ( jQuery( '.representative-single-post:hidden' ).length === 0 ) {
			jQuery( '.load-more' ).hide();
		}
	} );

	// Function to handle the "View All" category button click event
	jQuery( '.view-all-category' ).on( 'click', function() {
		jQuery( '.representative-single-post' ).slice( 0, itemsToShow ).show();
		if ( jQuery( '.representative-single-post' ).length > itemsToShow ) {
			jQuery( '.load-more' ).show();
		} else {
			jQuery( '.load-more' ).hide();
		}
	} );
} );

